"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onClickEvent = void 0;
var _addToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AddToBasketEvent = _addToBasket;
var OpenProductInfoDialog = _interopRequireWildcard(require("@ori-events/open-product-info-dialog"));
var OpenShadePicker = _interopRequireWildcard(require("@ori-events/open-shade-picker"));
var _analyticsData = require("@ori/analytics-data");
var _productBox = require("@ori/product-box");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const onClickEvent = (param)=>{
    let { pageIndex, product, personalSubscriptionsEnabled } = param;
    var _product_subscription, _product_concept;
    if ((product === null || product === void 0 ? void 0 : product.productCode) == null) {
        return;
    }
    const hasAutoSubscription = (0, _productBox.mapHasAutoSubscription)(product.labels);
    const hasPersonalSubscription = personalSubscriptionsEnabled && !!((_product_subscription = product.subscription) === null || _product_subscription === void 0 ? void 0 : _product_subscription.available);
    const isMultiShade = ((_product_concept = product.concept) === null || _product_concept === void 0 ? void 0 : _product_concept.products) && product.concept.products.length > 1;
    if (hasPersonalSubscription || hasAutoSubscription) {
        window.dispatchEvent(new CustomEvent(OpenProductInfoDialog.Name, {
            detail: {
                mode: OpenProductInfoDialog.DialogMode.StandardBuy,
                placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
                productCodes: [
                    product.productCode
                ]
            }
        }));
    } else if (isMultiShade) {
        window.dispatchEvent(new CustomEvent(OpenShadePicker.Name, {
            detail: {
                placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
                productCode: product.productCode
            }
        }));
    } else {
        var _product_formattedPrice_price, _product_formattedPrice, _product_concept1;
        var _product_formattedPrice_price_currentPrice, _product_concept_name;
        window.dispatchEvent(new CustomEvent(AddToBasketEvent.Name, {
            detail: {
                formattedPrice: (_product_formattedPrice_price_currentPrice = (_product_formattedPrice = product.formattedPrice) === null || _product_formattedPrice === void 0 ? void 0 : (_product_formattedPrice_price = _product_formattedPrice.price) === null || _product_formattedPrice_price === void 0 ? void 0 : _product_formattedPrice_price.currentPrice) !== null && _product_formattedPrice_price_currentPrice !== void 0 ? _product_formattedPrice_price_currentPrice : '',
                itemCode: product.productCode,
                localName: (_product_concept_name = (_product_concept1 = product.concept) === null || _product_concept1 === void 0 ? void 0 : _product_concept1.name) !== null && _product_concept_name !== void 0 ? _product_concept_name : '',
                method: _addToBasket.Method.BUY_FOR_MONEY,
                placement: _analyticsData.Placement.DigitalCatalogueECatalogue,
                position: pageIndex + 1,
                quantity: 1
            }
        }));
    }
};
exports.onClickEvent = onClickEvent;
